<template>
  <div>
    <div class="bg">
      <div class="box">
        <div class="router_box">
          <div class="left">
            <img src="../../assets/stylus/image/logo_2.png" />
            <div class="router_homes" @click="menu_router('/edit_home')">
              首页
            </div>
            <div class="router_home" @click="menu_router('/contest')">
              赛事
            </div>
          </div>
          <div class="right">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <img src="../../assets/stylus/image/head.png" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="我的项目">我的项目</el-dropdown-item>
                <el-dropdown-item command="logoOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div class="bg_background">
          <div class="left">
            <img src="../../assets/stylus/image/edit_bg.png" />
          </div>
          <div class="right">
            <img src="../../assets/stylus/image/head.png" />
            <p>立即开启编程之旅</p>
            <el-link type="primary" @click="my_project">我的项目</el-link>
            <el-button type="primary" size="mini" @click="start_writing">
              开始创作
            </el-button>
          </div>
        </div>
      </div>

      <div class="bottom_div">
        <ul>
          <li @click="choice_tag('')" :class="tag == '' ? 'active' : ''">
            所有
          </li>
          <li
            @click="choice_tag('游戏')"
            :class="tag == '游戏' ? 'active' : ''"
          >
            游戏
          </li>
          <li
            @click="choice_tag('动画')"
            :class="tag == '动画' ? 'active' : ''"
          >
            动画
          </li>
          <li
            @click="choice_tag('音乐')"
            :class="tag == '音乐' ? 'active' : ''"
          >
            音乐
          </li>
          <li
            @click="choice_tag('模拟')"
            :class="tag == '模拟' ? 'active' : ''"
          >
            模拟
          </li>
          <li
            @click="choice_tag('搞笑')"
            :class="tag == '搞笑' ? 'active' : ''"
          >
            搞笑
          </li>
          <li
            @click="choice_tag('故事')"
            :class="tag == '故事' ? 'active' : ''"
          >
            故事
          </li>
          <li
            @click="choice_tag('互动编程手柄')"
            :class="tag == '互动编程手柄' ? 'active' : ''"
          >
            互动编程手柄
          </li>
        </ul>
      </div>

      <div class="list_box">
        <ul>
          <li
            @click="to_router(item)"
            v-for="(item, index) in scratch_list.Results"
            :key="index"
          >
            <div style="height:84%;overflow:hidden;">
              <img :src="item.Image.Url" />
            </div>
            <div class="title">{{ item.WorkName }}</div>
          </li>
        </ul>
      </div>

      <div class="pagination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :hide-on-single-page="limit"
          :page-sizes="[40, 60, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="scratch_list.Total"
        >
        </el-pagination>
      </div>

      <fotter></fotter>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { get_community_api } from "@/api/scratch.js";
import { logonOut } from "@/api/login.js";
import store from "../../store";
import fotter from "../components/fotter.vue";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    fotter,
  },
  data() {
    return {
      scratch_list: [],
      tag: "",
      offset: 0,
      limit: 40,
    };
  },

  created() {
    this.getScratch();
  },

  methods: {
    handleCommand(item) {
      if (item == "我的项目") {
        this.$router.push({ path: "/my_works" });
      } else {
        logonOut().then(() => {
          this.$router.push({ path: "/" });
          window.sessionStorage.clear();
          store.dispatch("user/userInfo", {});
        });
      }
    },

    my_project() {
      this.$router.push({ path: "/my_works" });
    },

    start_writing() {
      var url = "/scratch/?stageArea=false";
      window.open(url);
    },

    //获取作品
    getScratch() {
      get_community_api(this.tag, this.offset, this.limit).then((res) => {
        this.scratch_list = res.data;
      });
    },

    //切换作品类型
    choice_tag(type) {
      this.tag = type;
      this.getScratch();
    },

    //分页
    handleSizeChange(val) {
      this.limit = val;
      this.getScratch();
    },

    //分页
    handleCurrentChange(val) {
      this.offset = (val - 1) * this.limit;
      this.getScratch();
    },

    //跳转
    to_router(item) {
      this.$router.push({ path: "/detailed", query: item });
    },

    menu_router(item) {
      this.$router.push({ path: item });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-dropdown {
    position: relative;
    top:50%;
    transform:translateY(-50%);
}
.bg {
  width:100%;
  height:734px;
  background-image: url(../../assets/stylus/image/bg-head.png);
  .box {
     width:86%;
     padding:12px;
     margin:0 auto;

     .router_box {
       width:100%;
       display:flex;
       justify-content:space-between;
       .left {
          width:26%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          img {
            width:130px;
            margin-right:30px;
          }
          .router_home {
            padding: 10px 20px;
              color: white;
              font-size:14px;
              cursor: pointer;
          }
          .router_homes {
              color: white;
              font-size:14px;
              cursor: pointer;
              padding: 10px 20px;
              background: #d59504;
              border-radius: 20px;
          }
          .router_home:hover {
            padding: 10px 20px;
            background: #d59504;
            border-radius: 20px;

          }
       }

       .right {
          img {
            width:30px;
          }
       }
     }

     .bg_background {
        margin-top:60px;
        display: flex;
        justify-content: space-between;
        .left {
          width:76%;
          img {
            width:100%;
            border:2px solid #fff;
            border-radius: 6px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
          }
        }
        .right {
          width: 20%;
          background: #fff;
          border-radius: 6px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          position: relative;
          img {
            width:100px;
            position:absolute;
            top:10%;
            left: 50%;
            transform: translate(-50%, 0%);
          }
          p {
            width:100%;
            color: #777;
            font-size:14px;
            position:absolute;
            top:54%;
            text-align: center;
          }
          .el-link {
            font-size:14px;
            position:absolute;
            top:64%;
            left: 50%;
            transform: translate(-50%, 0%);
          }
          .el-button {
            position:absolute;
            bottom:6%;
            left: 50%;
            transform: translate(-50%, 0%);
            width:70%;
          }
        }
     }
  }

  .bottom_div {
    background: #ffb000;
    ul {
      width:86%;
      margin:0 auto;
      display:flex;
      color: white;
      font-size: 14px;
      padding:12px;
      li {
        padding:8px;
        margin-right:20px;
      }

      li:hover {
        cursor: pointer;
        padding:8px;
        border-radius:20px;
        background: rgba(0,0,0,0.2);
        margin-right:20px;
        transition: all 0.4s;
      }

      .active {
        padding:8px;
        border-radius:20px;
        background: rgba(0,0,0,0.2);
      }
    }
  }

  .list_box {
    width:100%;
    margin-top:20px;
    ul {
      width:84%;
      margin:0 auto;
      display:flex;
      justify-content:space-between;
      flex-wrap:wrap;
      padding-bottom:30px;
      li {
        width:18.8%;
        height:280px;
        background:#fff;
        border-radius:6px;
        overflow:hidden;
        position:relative;
        cursor: pointer;
        margin-bottom:1.4%;
        img {
          height:100%;
        }
        img:hover {
          height:105%;
          transition:all 0.5s;
        }
        .title {
          position:absolute;
          bottom:0;
          width:100%;
          text-align:center;
          padding:16px 0;
        }
      }

      li:hover {
        color: #409EFF;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transition:all 0.5s;
      }
    }
  }

  .pagination {
    width:84%;
    height:80px;
    margin:0 auto;

    .el-pagination {
      float:right;
      margin-bottom:30px;
    }
  }
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
